import { RACKET_SPORTS } from './profileOptions';

// Readable display name for a sport value, e.g. "table_tennis" -> "Table Tennis".
// Falls back to a plain capitalized version if the value isn't in RACKET_SPORTS.
export function sportLabel(sport) {
  if (!sport) return 'Event';
  return RACKET_SPORTS.find(s => s.value === sport)?.label
    || sport.charAt(0).toUpperCase() + sport.slice(1);
}

// Squash and table tennis don't really have "net play" as a rateable skill —
// squash has no net to approach (it's a continuous rally off the front
// wall), and table tennis's analogous skill is playing close to the table
// rather than approaching a net. Their own tactical vocabulary calls this
// the "short game" (squash: front-court/short shots vs. back-court length;
// table tennis: close-to-table exchanges vs. playing from distance).
// Tennis, padel, badminton and pickleball all genuinely call this net play —
// it's a real, named skill category in each of those.
const SHORT_GAME_SPORTS = ['squash', 'table_tennis'];

export function netPlayLabel(sport) {
  return SHORT_GAME_SPORTS.includes(sport) ? 'Short game' : 'Net play';
}

export function netPlayIcon(sport) {
  return SHORT_GAME_SPORTS.includes(sport) ? '🎯' : '🥅';
}
